import React from 'react';
import { CTAButton } from './CTAButton';
import { ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="bg-[#1f2e10] text-white py-20 px-4 border-t-4 border-[#c4f000]" data-id="element-55">
      <div className="max-w-4xl mx-auto text-center" data-id="element-56">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-10 leading-tight" data-id="element-57">
          NON ASPETTARE CHE LA PROSSIMA SETTIMANA SIA IDENTICA A QUELLA APPENA
          FINITA
        </h2>

        <div className="space-y-4 text-xl md:text-2xl text-gray-300 mb-12 font-medium" data-id="element-58">
          <p data-id="element-59">
            Inizia oggi a costruire abitudini alimentari più sane per i tuoi
            bambini.
          </p>
          <p className="text-white font-bold" data-id="element-60">Con meno stress.</p>
          <p className="text-white font-bold" data-id="element-61">Meno tempo in cucina.</p>
          <p className="text-[#c4f000] font-black text-3xl mt-6" data-id="element-62">
            E molta più serenità.
          </p>
        </div>

        <div className="flex justify-center mb-8" data-id="element-63">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} data-id="element-64">
            <ArrowDown size={40} className="text-white" data-id="element-65" />
          </motion.div>
        </div>

        <div className="mb-16" data-id="element-66">
          <CTAButton href="#pricing" className="text-xl py-6 px-10 font-black tracking-wide" data-id="element-67">
            ACCEDI ORA A MERENDE FELICI™
          </CTAButton>
        </div>

        <div className="text-xs text-gray-500 border-t border-white/10 pt-8 max-w-2xl mx-auto" data-id="element-68">
          <p className="mb-2" data-id="element-69">
            © {new Date().getFullYear()} Merende Felici™. Tutti i diritti
            riservati.
          </p>
          <p data-id="element-70">
            Questo sito non fa parte del sito web di Facebook o Facebook Inc.
            Inoltre, questo sito NON è approvato da Facebook in alcun modo.
            FACEBOOK è un marchio registrato di FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </section>;
}